import { createSelector } from 'reselect';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';

/**
 * True when the current labor ticket is CLOSED while an operator is still signed
 * in — the "keep-open" state.
 *
 * getCurrentLaborTicket only surfaces a CLOSED ticket in the NATS keep-open flow
 * (see getLaborTickets); every other CLOSED ticket is hidden as null. So a
 * CLOSED ticket here means: the operator closed their ticket but the production
 * run was intentionally left open for the next operator, yet this operator is
 * still signed in. In that state there is nothing left to submit — the only
 * meaningful action is a plain sign-out that ends the operator run (no new
 * labor ticket, no form).
 */
const getHasClosedKeepOpenLaborTicket = createSelector(
  [getCurrentLaborTicket],
  (currentLaborTicket) => {
    return currentLaborTicket?.state === 'CLOSED';
  }
);

export { getHasClosedKeepOpenLaborTicket };
